import React, { FC } from 'react'
import { AudiogramRotativePointProps, audiogramPointSize } from '../../AudiogramPoint.model'

export const ChevronPoint: FC<AudiogramRotativePointProps> = ({
  color,
  lowerChevron,
  orientation,
}) => {
  return (
    <svg
      width={audiogramPointSize}
      height={audiogramPointSize}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
    >
      <g stroke={color} fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
        <polyline
          id="chevron"
          strokeWidth="2"
          points={orientation === 'right' ? '8,11 17,16 8,21' : '24,11 15,16 24,21'}
        />
        {lowerChevron && <polyline id="chevron" points="18,24 21,27 24,24" />}
      </g>
    </svg>
  )
}
